import styled from "@emotion/styled";

const DatePickerToolbar = styled.div`
  display: flex;
  gap: 4px;
`;

export default DatePickerToolbar;
